import JobCard from './JobCard';
// import { data } from './mockData';
import './styles.scss';

const JobCards = ({ data = [] }) => (
    <div className="job-cards">
        {data.map(item => (
            <JobCard key={item.title} item={item} />
        ))}
    </div>
);

export default JobCards;
